import { render, staticRenderFns } from "./main_settings.vue?vue&type=template&id=865a0aa2&"
import script from "./main_settings.vue?vue&type=script&lang=js&"
export * from "./main_settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports